import React from 'react'

export const feedbackInvestData = [
	{
		name: 'Татьяна М.',
		position: 'профессионал в сфере лизинга и инвестор в декрете',
		avatarUrl: 'female-1.png',
		shortText: (
			<>
				&laquo;К накоплению денег я отношусь положительно, всегда часть дохода откладываю и считаю
				это нормой. Такой подход позволил мне купить несколько квартир, которые стали одним из
				источников пассивного дохода.
			</>
		),
		text: (
			<>
				&laquo;К накоплению денег я отношусь положительно, всегда часть дохода откладываю и считаю
				это нормой. Такой подход позволил мне купить несколько квартир, которые стали одним из
				источников пассивного дохода. <br /> <br /> Так же я инвестировала в такие инструменты, как
				депозиты, акции российских и американских компаний, паевые фонды, ETF и облигации. Сейчас, к
				сожалению, на моих счетах есть часть замороженных средств в ряде вышеперечисленных
				инструментов, что приносит мне моральный дискомфорт. <br /> <br /> О компании Credit.Club и
				Сбережениях я узнала на сайте Банки.Ру, привлекла структура бизнеса и соотношение надёжности
				и ликвидности. Мы с мужем аккумулируем средства на дом, в планах летом начать строительство,
				поэтому такой инструмент, как Сбережения, нам подходит по всем параметрам. Кстати, муж мой
				тоже является вашим клиентом.&raquo;
			</>
		),
	},

	{
		name: 'Олег Л.',
		position: 'самозанятый инвестор',
		avatarUrl: 'male-1.png',
		shortText: (
			<>
				&laquo;Моим основным стимулом инвестировать деньги стало стремление накопить на достойную
				жизнь на пенсии, так как понимал, что обычной пенсии на это вряд ли хватит.
			</>
		),
		text: (
			<>
				&laquo;Моим основным стимулом инвестировать деньги стало стремление накопить на достойную
				жизнь на пенсии, так как понимал, что обычной пенсии на это вряд ли хватит. <br /> <br />{' '}
				Начал думать над источниками дополнительного пассивного дохода. В итоге создал несколько:
				коммерческие займы, акции, облигации и т.д. <br /> <br /> Потом в телеграме наткнулся на
				продукт Credit.Club. Всё более чем понятно: выдают деньги под залог жилья, низкая
				вероятность потери сбережений. <br /> <br /> Некоторое время присматривался, потом решил
				сделать первый взнос. В Сбережениях мне особенно понравилось, что выплаты ежемесячные и
				можно их использовать для других целей, в связи с чем оборачиваемость денег растёт. <br />{' '}
				<br /> Кстати, после окончания договора мне средства пришли уже в течении 3 часов после
				заявления. <br /> <br /> Продуктом остался доволен, поэтому порекомендовал его друзьям и
				теперь намерен получать ещё средства с реферальной программы&raquo;
			</>
		),
	},

	{
		name: 'Любовь Б.',
		position: 'учитель географии на пенсии',
		avatarUrl: 'female-2.png',
		shortText: (
			<>
				&laquo;О моём отношении к деньгам можно сказать так: я стараюсь откладывать всё, что
				возможно; экономлю, не покупаю лишнего и не шикую. Такие привычки у меня сложились давно:
				ещё в период трудовой деятельности, ведь зарплата учителя в маленькой школе никогда не была
				высокой.
			</>
		),
		text: (
			<>
				&laquo;О моём отношении к деньгам можно сказать так: я стараюсь откладывать всё, что
				возможно; экономлю, не покупаю лишнего и не шикую. Такие привычки у меня сложились давно:
				ещё в период трудовой деятельности, ведь зарплата учителя в маленькой школе никогда не была
				высокой. <br /> <br /> Основной целью накопления у меня была квартира для дочки. Остаток от
				её покупки держала только на вкладах, но постоянно перекладывая между банками в нашем городе
				в поиске более привлекательных условий. <br /> <br /> Сбережения мне посоветовал зять — он
				работает в Credit.Club и тоже держит там часть денег. Я использую Сбережения уже больше
				полутора лет как стабильную прибавку к пенсии — очень выручает такая возможность, в банках
				нашего города похожих условий не найти&raquo;
			</>
		),
	},
	{
		name: 'Семён А.',
		position: 'активный предприниматель',
		shortText: (
			<>
				&laquo;Сейчас я добился того, что не трачу время на работу и дорогу до неё, а провожу все
				дни за городом с семьёй. При этом зарабатываю на жизнь с помощью пассивного дохода
			</>
		),
		text: (
			<>
				&laquo;Считаю себя активным предпринимателем, который старается находить новые способы
				заработка, в том числе и пассивные. <br /> <br />
				Деньги стараюсь не держать без дела: мне важно, чтобы они всё время находились в обороте.
				Постоянно пробую разные инструменты: биржа, крауд, криптовалюта. <br /> <br />
				Из пассивных способов заработка мне понравилось сотрудничество с Credit.Club. У них всё
				грамотно организовано: подписание документов, выплаты, возврат денег, общение с менеджером.
				Ключевым же фактором для принятия решения о первом размещении была рекомендация от человека,
				который уже воспользовался услугами Credit.Club. В будущем обязательно буду использовать
				возможности компании для накопления средств&raquo;
			</>
		),
	},
	{
		name: 'Сергей Ч.',
		position: 'живёт за городом и получает пассивный доход',
		shortText: (
			<>
				&laquo;Считаю себя активным предпринимателем, который старается находить новые способы
				заработка, в том числе и пассивные
			</>
		),
		text: (
			<>
				&laquo;Сейчас я добился того, что не трачу время на работу и дорогу до неё, а провожу все
				дни за городом с семьёй. При этом зарабатываю на жизнь с помощью пассивного дохода. <br />{' '}
				<br />
				Вообще копить деньги я привык с детства, ибо в 90-е годы по-другому нельзя было ничего
				купить себе интересного, даже на сникерсы надо было копить. Так что привычка такая у меня
				сформировалась давно. <br /> <br />А вот погружаться в инвестиции я начал с 2009 года. В
				самый разгар кризиса полгода активно торговал на бирже, глубоко изучал эту тему, но потом
				бросил. В 2014 году мне подарили книги Киосаки, и они вдохновили меня развивать тему
				пассивного дохода, благодаря которому я сейчас могу спокойно себе гулять по лесу, загорать и
				купаться. Кстати, начал пассивный доход я со сдачи квартиры в аренду: сперва свою, потом
				купил вторую. Позже добавился ещё и гараж. <br /> <br />
				Что касается Сбережений, то я давно наблюдал за вашей компанией, и хотя меня сначала смущала
				относительно небольшая доходность, всё же решил, что для диверсификации надо и сюда
				вложиться. Сейчас уже активно пополняю счёт, как появляются свободные деньги. Хочу довести
				сумму до ощутимых для себя ежемесячных выплат. <br /> <br />В вашем продукте мне нравится
				то, что всё происходит быстро и удобно: решил в любое время внести деньги — вперёд. Не надо
				никуда ездить и даже на почте договор не надо получать, сканировать его и заново высылать.
				Для загородной жизни — это отличный вариант инвестирования&raquo;
			</>
		),
	},
	{
		name: 'Лариса С.',
		position: 'работает в крупном производственном холдинге',
		shortText: (
			<>
				&laquo;Я довольно консервативный инвестор и все решения касаемо размещения накоплений мне
				даются непросто. Мне легче опереться на опыт людей, которые уже пользуются инвестиционными
				инструментами и имеют положительный результат. Именно такой рекомендации я и последовала,
				начав инвестировать в Сбережения по совету подруги, которая уже является вашим клиентом
			</>
		),
		text: (
			<>
				&laquo;Я довольно консервативный инвестор и все решения касаемо размещения накоплений мне
				даются непросто. Мне легче опереться на опыт людей, которые уже пользуются инвестиционными
				инструментами и имеют положительный результат. Именно такой рекомендации я и последовала,
				начав инвестировать в Сбережения по совету подруги, которая уже является вашим клиентом.{' '}
				<br /> <br />
				Для меня накопления — это возможность иметь дополнительный пассивный доход, тем более что до
				выхода на пенсию мне осталось 5 лет. <br /> <br />
				Сбережения — не единственный источник моего пассивного дохода, ещё я сдаю квартиру в аренду.
				По моим подсчётам, доходность Сбережений выше, чем от аренды квартиры с учётом её перегретой
				рыночной цены в нашем регионе. Так что планирую продать недвижимость сейчас на пике и в
				дальнейшем распределить часть денег с продажи в Credit.Club. <br /> <br />
				Спасибо компании Credit.Club за стабильный бизнес и возможность получать достойный
				доход&raquo;
			</>
		),
	},
]

export const feedbackInvestorsData = [
	{
		name: 'Александр Василенко',
		position: 'инвестор',
		avatarUrl: 'male-2.png',
		href: 'https://percent.credit.club/aleksandr-vasilenko/',
		shortText: (
			<>
				Мне хотелось попробовать какой-то новый инвестиционный продукт в интересной обертке. Так я
				нашёл необычный финансовый инструмент — сбережения от Credit.Club. Это вроде бы привычный
				КПК, но в новой форме — он работает вместе с платформой цифровых решений, которая объединяет
				заёмщиков и инвесторов. Человек не привязан к какой-то территории — все сделки проводятся
				онлайн. Ещё платформа защищает деньги инвесторов залогом недвижимости.
			</>
		),
	},
	{
		name: 'Олег Булыгин',
		position: 'инвестор',
		avatarUrl: 'male-3.png',
		href: 'https://percent.credit.club/intervyu-s-investorom-olegom-bulyginym/',
		shortText: (
			<>
				Я выбрал «Сбережения» в Credit.Club по нескольким причинам: высокая доходность и
				предсказуемость в сравнении с другими инвестиционными инструментами, которые работают на
				основе кредитования физических лиц. На текущий момент процентная ставка в 13% годовых меня
				вполне устраивает. Но судить об итоговой доходности сбережений буду уже после окончания
				срока депозита.
			</>
		),
	},
]
